<button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h2 mat-dialog-title>Welcome to Sales Realization Tool</h2>

<mat-dialog-content class="mat-typography">
  <p>Please play below video for demo tour</p>
  <video
    *ngIf="finalVideoUrl"
    width="90%"
    height="90%"
    src="{{ finalVideoUrl }}"
    crossorigin="anonymous"
    controls
    #videoElement
    controlsList="nodownload"
  ></video>
  <p class="load" *ngIf="!finalVideoUrl">Loading....</p>
</mat-dialog-content>
